import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { ArrowRight, ShieldCheck, Loader2 } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useState } from 'react';
import { prepareOptionalSignIn } from '../lib/accountSync';

export const AuthDialog = () => {
  const { authOpen, setAuthOpen } = useApp();
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const login = async () => {
    setBusy(true); setError('');
    try { await prepareOptionalSignIn(); }
    catch (e) { setError(e.message); setBusy(false); }
  };
  return <Dialog open={authOpen} onOpenChange={setAuthOpen}><DialogContent className="tts-dialog auth-dialog" data-testid="auth-dialog">
    <img src="/icon-192.png" alt="Tap Talk Save" className="auth-logo" data-testid="auth-brand-icon" />
    <DialogTitle data-testid="auth-dialog-title">Sync Across Devices</DialogTitle>
    <DialogDescription data-testid="auth-dialog-description">Create an account to keep your saves available across your devices.</DialogDescription>
    <Button className="primary-button google-button" disabled={busy} onClick={login} data-testid="google-login-button">{busy ? <Loader2 size={18} className="spin" /> : <span className="google-g">G</span>}Continue with Google<ArrowRight size={17} /></Button>
    {error && <p role="alert" data-testid="account-sync-error">{error}</p>}
    <p className="auth-note" data-testid="auth-account-note"><ShieldCheck size={15} /> Optional. No account needed for everyday use.</p>
    <button className="text-button" onClick={() => setAuthOpen(false)} disabled={busy} data-testid="continue-as-guest-button">Continue without an account</button>
  </DialogContent></Dialog>;
};